import React from 'react'
import { ThemeProvider } from 'react-jss'
import { theme } from '../ui/theme'

import DynamicContent from '../DynamicContent'

const GenericPage = () => {
  const context = JSON.parse(
    atob(
      atob(data)
        .split('')
        .reverse()
        .join(''),
    )
      .split('')
      .reverse()
      .join(''),
  )

  return (
    <ThemeProvider theme={theme}>
      <DynamicContent {...context.ResponsiveContent} />
    </ThemeProvider>
  )
}

export default GenericPage
